export const SET_ADDRESS = 'SET_ADDRESS';
export const ADD_ADDRESS = 'ADD_ADDRESS';
export const REPLACE_ADDRESS = 'REPLACE_ADDRESS';
export const SET_USER_VISIBLE_COLUMNS = 'SET_USER_VISIBLE_COLUMNS';